import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DatepickerBox from './datepicker-box';
import Tooltip from '../tooltip/tooltip';
import { CalenderIcon, InfoIcon } from '../icons/icons';
import { fetchUtcDate } from '../../helpers/dateHelper';

function ProposeChangeDatePicker({
  onChange,
  selectedDate,
  placeholder,
  disabled,
  otherDate,
  showError,
  isClear,
  kind,
  restrictPastDate,
  errorMessage,
  ...otherProps
}) {
  const [t] = useTranslation('manageorders');
  const [localErrorMessage, setLocalErrorMessage] = useState('');
  // const [primaryDate, setPrimaryDate] = useState('');
  const handleChangeDate = (date) => {
    const today = new Date().setHours(0, 0, 0, 0);
    const selected = new Date(date).setHours(0, 0, 0, 0);
    if (!date) {
      // setPrimaryDate(null);
      if (!showError) return;
      setLocalErrorMessage(
        t(
          'manageordersscreen.orderdetails.deliverySchedule.validation.noDateErr'
        )
      );
    } else if (
      restrictPastDate &&
      new Date(date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
    ) {
      setLocalErrorMessage(
        t(
          'manageordersscreen.orderdetails.deliverySchedule.validation.pastDateErr'
        )
      );
    } else if (
      kind === 'delivery' &&
      otherDate &&
      new Date(date).setHours(0, 0, 0, 0) <
        new Date(fetchUtcDate(otherDate)).setHours(0, 0, 0, 0)
    ) {
      setLocalErrorMessage(
        t(
          'manageordersscreen.orderdetails.deliverySchedule.validation.deliveryDateErr'
        )
      );
      // setPrimaryDate(null);
    } else if (
      kind === 'CR' &&
      otherDate &&
      new Date(date).setHours(0, 0, 0, 0) >
        new Date(fetchUtcDate(otherDate)).setHours(0, 0, 0, 0)
    ) {
      setLocalErrorMessage(
        t(
          'manageordersscreen.orderdetails.deliverySchedule.validation.CRDateErr'
        )
      );
      // setPrimaryDate(null);
    }
    // else if (selected < today) {
    //   setLocalErrorMessage('Please select a future date');
    //   setPrimaryDate(date);
    // }
    else if (selected > today) {
      setLocalErrorMessage('');
      // setPrimaryDate(date);
    } else {
      setLocalErrorMessage('');
      // setPrimaryDate(date);
    }
  };

  useEffect(() => {
    if (isClear) {
      setLocalErrorMessage('');
    }
    if (showError || (otherDate && localErrorMessage)) {
      handleChangeDate(selectedDate);
    } else {
      setLocalErrorMessage('');
    }
  }, [showError, otherDate, isClear]);
  return (
    <div
      className={`propose-change-date-picker ${
        localErrorMessage ? 'error' : ''
      }${errorMessage ? 'error' : ''}`}
    >
      <DatepickerBox
        disabled={disabled}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        // selectedDate={selectedDate || primaryDate}
        selectedDate={selectedDate}
        setDate={(e) => {
          handleChangeDate(e);
        }}
        disableIcon
        {...otherProps}
      />
      {(localErrorMessage || errorMessage) && (
        <Tooltip content={localErrorMessage || errorMessage} direction="right">
          <InfoIcon width="0.694vw" color="#f00" height="0.694vw" />
        </Tooltip>
      )}
      <CalenderIcon color={localErrorMessage ? '#f00' : ''} />
    </div>
  );
}

export default ProposeChangeDatePicker;
ProposeChangeDatePicker.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  otherDate: PropTypes.instanceOf(Date),
  showError: PropTypes.bool,
  isClear: PropTypes.bool,
  kind: PropTypes.string,
  restrictPastDate: PropTypes.bool,
  errorMessage: PropTypes.string,
};
ProposeChangeDatePicker.defaultProps = {
  placeholder: '',
  disabled: false,
  onChange: () => {},
  otherDate: '',
  showError: false,
  isClear: false,
  kind: '',
  restrictPastDate: false,
  errorMessage: '',
};
